export default {
  AWS_LAMBDA_GETSIGNEDURL_ENDPOINT: 'https://0um1se62k3.execute-api.us-east-1.amazonaws.com/dev/prepare-non-video-upload',
  UPLOAD_FILEPATH_TEMPLATE: 'kb/organizations',
  RETRIEVE_FILEPATH_CDN: 'organizations',
  region: process.env.VUE_APP_AWS_REGION,
  IdentityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID,
  UserPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
  ClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
}